// import { MIME_TYPES } from "../../../constants";

// 檔案大小限制
export const IMAGE_SIZE_LIMIT = 10 * 1024 * 1024; // 10MB
export const VIDEO_SIZE_LIMIT = 500 * 1024 * 1024; // 500MB

// 數量限制
export const MAX_KEYWORD_AMOUNT = 10;

// 檔案類型
export const IMG_ACCEPT_TYPES = ["image/jpeg", "image/png", "image/gif"];
export const VIDEO_ACCEPT_TYPES = ["mp4"];

// 內容長度限制
export const MAX_CONTENT_LENGTH = 3000; // 暫時開到 3000 字
export const RECORD_PAGE_LIMIT = 7;
